<template>
    <div v-if="visible" class="remark-overlay" @click.self="handleMaskClick">
        <div class="remark-dialog" role="dialog" aria-modal="true">
            <div class="dialog-header">
                <div class="dialog-title">{{ title }}</div>
                <button class="close-btn" type="button" @click="handleCancel" aria-label="Close">
                    <i class="el-icon-close"></i>
                </button>
            </div>
            <div class="dialog-body">
                Confirm completion of order?
            </div>
            <!-- <div class="dialog-body">
                <el-input v-model="text" type="textarea" :rows="rows" :maxlength="maxlength"
                    :show-word-limit="showWordLimit" :placeholder="placeholder" resize="none" />
            </div> -->

            <div class="dialog-footer">
                <el-button class="btn" @click="handleCancel">Cancel</el-button>
                <el-button class="btn primary" type="primary" :loading="loading"
                    :disabled="required && !String(text).trim()" @click="handleConfirm">
                    Confirm
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RemarkDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: 'Add Remark'
        },
        placeholder: {
            type: String,
            default: 'Please enter remark...'
        },
        maxlength: {
            type: Number,
            default: 200
        },
        rows: {
            type: Number,
            default: 5
        },
        required: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        closeOnMask: {
            type: Boolean,
            default: true
        },
        showWordLimit: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            text: ''
        }
    },
    watch: {
        visible: {
            immediate: true,
            handler(v) {
                if (v) this.text = this.value || ''
            }
        },
        value(v) {
            if (!this.visible) return
            if (v !== this.text) this.text = v || ''
        },
        text(v) {
            this.$emit('input', v)
            this.$emit('change', v)
        }
    },
    methods: {
        handleMaskClick() {
            if (!this.closeOnMask) return
            this.handleCancel()
        },
        handleCancel() {
            this.$emit('update:visible', false)
            this.$emit('cancel')
        },
        handleConfirm() {
            const v = String(this.text || '')
            this.$emit('confirm', v)
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.remark-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    padding-left: calc(24px + env(safe-area-inset-left));
    padding-right: calc(24px + env(safe-area-inset-right));
    padding-bottom: calc(24px + env(safe-area-inset-bottom));
}

.remark-dialog {
    width: 520px;
    max-width: 100%;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.18) 0px 10px 30px;
}

.dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.dialog-title {
    font-size: 16px;
    font-weight: 600;
    color: #111;
}

.close-btn {
    border: none;
    background: transparent;
    cursor: pointer;
    color: #666;
    padding: 6px;
    border-radius: 8px;

    &:hover {
        background: rgba(0, 0, 0, 0.04);
        color: #111;
    }
}

.dialog-body {
    padding: 16px;

    ::v-deep .el-textarea__inner {
        border-radius: 10px;
        line-height: 1.5;
    }
}

.dialog-footer {
    padding: 12px 16px 16px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.btn.primary {
    background: #000 !important;
    border: none !important;

    &:hover {
        background: #333 !important;
    }
}

@media screen and (max-width: 768px) {
    .remark-overlay {
        align-items: flex-end;
        padding: 12px;
        padding-left: calc(12px + env(safe-area-inset-left));
        padding-right: calc(12px + env(safe-area-inset-right));
        padding-bottom: calc(12px + env(safe-area-inset-bottom));
    }

    .remark-dialog {
        width: 100%;
        border-radius: 14px;
    }

    .dialog-footer {
        justify-content: stretch;

        .el-button {
            flex: 1;
        }
    }
}
</style>
